interface InvoiceData {
  order: any
  customerName: string
  customerPhone: string
  paymentMethod: string
}

export function generateInvoicePDF(data: InvoiceData) {
  try {
    // Criar conteúdo HTML para o PDF
    const htmlContent = generateInvoiceHTML(data)

    // Criar uma nova janela para impressão
    const printWindow = window.open("", "_blank")
    if (!printWindow) {
      throw new Error("Não foi possível abrir janela de impressão")
    }

    printWindow.document.write(htmlContent)
    printWindow.document.close()

    // Aguardar carregamento e imprimir
   //  printWindow.onload = () => {
     //  printWindow.print()

      // Fechar janela após impressão (opcional)
   //    printWindow.onafterprint = () => {
     //    printWindow.close()
    //   }
    // }
  } catch (error) {
    console.error("Erro ao gerar PDF:", error)

    // Fallback: baixar como arquivo de texto
    downloadAsText(data)
  }
}

function generateInvoiceHTML(data: InvoiceData): string {
  const { order, customerName, customerPhone, paymentMethod } = data
  const currentDate = new Date()

  // Corrigir estrutura dos itens - usar a estrutura correta do pedido
  const items = order.itens || []
  const total = items.reduce((sum: number, item: any) => {
    // Verificar se tem a estrutura correta: item.prato.preco e item.quantidade
    const preco = item.prato?.preco || item.preco || 0
    const quantidade = item.quantidade || 1
    return sum + preco * quantidade
  }, 0)

  const formatPrice = (price: number) => {
    return new Intl.NumberFormat("pt-AO", {
      style: "currency",
      currency: "AOA",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(price)
  }

  const formatDate = (dateString: string) => {
    try {
      return new Date(dateString).toLocaleDateString("pt-AO", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      })
    } catch {
      return currentDate.toLocaleDateString("pt-AO")
    }
  }

  const formatTime = (dateString: string) => {
    try {
      return new Date(dateString).toLocaleTimeString("pt-AO", {
        hour: "2-digit",
        minute: "2-digit",
      })
    } catch {
      return currentDate.toLocaleTimeString("pt-AO", {
        hour: "2-digit",
        minute: "2-digit",
      })
    }
  }

  return `
    <!DOCTYPE html>
    <html lang="pt-AO">
    <head>
      <meta charset="UTF-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>Fatura - Pedido #${order._id?.slice(-6) || "N/A"}</title>
      <style>
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }
        
        body {
          font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
          line-height: 1.6;
          color: #333;
          background: #f8f9fa;
          padding: 20px;
        }
        
        .invoice-container {
          max-width: 800px;
          margin: 0 auto;
          background: white;
          border-radius: 12px;
          box-shadow: 0 4px 20px rgba(0,0,0,0.1);
          overflow: hidden;
        }
        
        .invoice-header {
          background: linear-gradient(135deg, #f97316 0%, #ea580c 100%);
          color: white;
          padding: 40px 30px;
          text-align: center;
          position: relative;
        }
        
        .invoice-header::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="grain" width="100" height="100" patternUnits="userSpaceOnUse"><circle cx="25" cy="25" r="1" fill="white" opacity="0.1"/><circle cx="75" cy="75" r="1" fill="white" opacity="0.1"/><circle cx="50" cy="10" r="0.5" fill="white" opacity="0.1"/><circle cx="10" cy="60" r="0.5" fill="white" opacity="0.1"/><circle cx="90" cy="40" r="0.5" fill="white" opacity="0.1"/></pattern></defs><rect width="100" height="100" fill="url(%23grain)"/></svg>');
          pointer-events: none;
        }
        
        .invoice-header h1 {
          font-size: 32px;
          font-weight: bold;
          margin-bottom: 8px;
          position: relative;
          z-index: 1;
        }
        
        .invoice-header .subtitle {
          opacity: 0.9;
          font-size: 18px;
          font-weight: 300;
          position: relative;
          z-index: 1;
        }
        
        .invoice-header .location {
          opacity: 0.8;
          font-size: 14px;
          margin-top: 8px;
          position: relative;
          z-index: 1;
        }
        
        .invoice-body {
          padding: 40px 30px;
        }
        
        .invoice-info {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 40px;
          margin-bottom: 40px;
          padding-bottom: 30px;
          border-bottom: 2px solid #f1f5f9;
        }
        
        .info-section h3 {
          color: #f97316;
          font-size: 16px;
          font-weight: 700;
          margin-bottom: 16px;
          text-transform: uppercase;
          letter-spacing: 1px;
          display: flex;
          align-items: center;
          gap: 8px;
        }
        
        .info-section h3::before {
          content: '';
          width: 4px;
          height: 20px;
          background: linear-gradient(135deg, #f97316, #ea580c);
          border-radius: 2px;
        }
        
        .info-section p {
          margin-bottom: 8px;
          font-size: 15px;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        
        .info-section .label {
          color: #64748b;
          font-weight: 500;
        }
        
        .info-section .value {
          color: #1e293b;
          font-weight: 600;
        }
        
        .order-number {
          background: linear-gradient(135deg, #f97316, #ea580c);
          color: white;
          padding: 8px 16px;
          border-radius: 20px;
          font-weight: bold;
          font-size: 14px;
          display: inline-block;
        }
        
        .status-badge {
          background: #10b981;
          color: white;
          padding: 4px 12px;
          border-radius: 12px;
          font-size: 12px;
          font-weight: 600;
          text-transform: uppercase;
        }
        
        .items-section {
          margin-bottom: 40px;
        }
        
        .items-section h3 {
          color: #1e293b;
          font-size: 20px;
          font-weight: 700;
          margin-bottom: 20px;
          display: flex;
          align-items: center;
          gap: 10px;
        }
        
        .items-section h3::before {
          content: '🍽️';
          font-size: 24px;
        }
        
        .items-table {
          width: 100%;
          border-collapse: collapse;
          border-radius: 12px;
          overflow: hidden;
          box-shadow: 0 4px 12px rgba(0,0,0,0.05);
        }
        
        .items-table th {
          background: linear-gradient(135deg, #f8fafc, #e2e8f0);
          color: #475569;
          font-weight: 700;
          padding: 20px 16px;
          text-align: left;
          font-size: 14px;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          border-bottom: 2px solid #e2e8f0;
        }
        
        .items-table td {
          padding: 20px 16px;
          border-bottom: 1px solid #f1f5f9;
          font-size: 15px;
          vertical-align: middle;
        }
        
        .items-table tr:nth-child(even) {
          background: #fafbfc;
        }
        
        .items-table tr:hover {
          background: #f0f9ff;
          transform: scale(1.001);
          transition: all 0.2s ease;
        }
        
        .item-name {
          font-weight: 600;
          color: #1e293b;
          font-size: 16px;
        }
        
        .item-description {
          color: #64748b;
          font-size: 13px;
          margin-top: 4px;
          font-style: italic;
        }
        
        .item-quantity {
          text-align: center;
          font-weight: 600;
          color: #f97316;
          font-size: 16px;
        }
        
        .item-price {
          font-weight: 600;
          color: #1e293b;
          text-align: right;
          font-size: 15px;
        }
        
        .item-total {
          font-weight: 700;
          color: #f97316;
          text-align: right;
          font-size: 16px;
        }
        
        .total-section {
          background: linear-gradient(135deg, #f8fafc, #f1f5f9);
          padding: 30px;
          border-radius: 12px;
          margin-bottom: 30px;
          border: 1px solid #e2e8f0;
        }
        
        .total-row {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 12px 0;
          font-size: 16px;
        }
        
        .total-row.subtotal {
          color: #64748b;
          border-bottom: 1px solid #e2e8f0;
          margin-bottom: 12px;
          padding-bottom: 16px;
        }
        
        .total-row.final {
          border-top: 3px solid #f97316;
          margin-top: 16px;
          padding-top: 20px;
          font-size: 24px;
          font-weight: bold;
          color: #1e293b;
        }
        
        .total-amount {
          color: #f97316;
          font-size: 28px;
          font-weight: 900;
        }
        
        .invoice-footer {
          text-align: center;
          padding: 30px;
          background: linear-gradient(135deg, #f8fafc, #f1f5f9);
          border-top: 1px solid #e2e8f0;
        }
        
        .invoice-footer .thank-you {
          font-size: 18px;
          font-weight: 600;
          color: #1e293b;
          margin-bottom: 8px;
        }
        
        .invoice-footer .note {
          color: #64748b;
          font-size: 14px;
          margin-bottom: 16px;
        }
        
        .powered-by {
          color: #f97316;
          font-weight: 700;
          font-size: 14px;
          text-decoration: none;
        }
        
        .powered-by:hover {
          text-decoration: underline;
        }
        
        @media print {
          body {
            background: white;
            padding: 0;
          }
          
          .invoice-container {
            box-shadow: none;
            border-radius: 0;
          }
          
          .items-table tr:hover {
            transform: none;
          }
        }
        
        @media (max-width: 600px) {
          .invoice-info {
            grid-template-columns: 1fr;
            gap: 20px;
          }
          
          .items-table {
            font-size: 12px;
          }
          
          .items-table th,
          .items-table td {
            padding: 12px 8px;
          }
          
          .invoice-header h1 {
            font-size: 24px;
          }
          
          .total-row.final {
            font-size: 20px;
          }
          
          .total-amount {
            font-size: 24px;
          }
        }
      </style>
    </head>
    <body>
      <div class="invoice-container">
        <div class="invoice-header">
          <h1>Syncmenu</h1>
          <p class="subtitle">Fatura de Pedido</p>
          <p class="location">Huíla, Angola</p>
        </div>
        
        <div class="invoice-body">
          <div class="invoice-info">
            <div class="info-section">
              <h3>Cliente</h3>
              <p>
                <span class="label">Nome:</span>
                <span class="value">${customerName}</span>
              </p>
              <p>
                <span class="label">Telefone:</span>
                <span class="value">${customerPhone}</span>
              </p>
              <p>
                <span class="label">Pagamento:</span>
                <span class="value">${paymentMethod}</span>
              </p>
            </div>
            
            <div class="info-section">
              <h3>Pedido</h3>
              <p>
                <span class="label">Número:</span>
                <span class="order-number">#${order._id?.slice(-6) || "N/A"}</span>
              </p>
              <p>
                <span class="label">Data:</span>
                <span class="value">${formatDate(order.createdAt || currentDate.toISOString())}</span>
              </p>
              <p>
                <span class="label">Hora:</span>
                <span class="value">${formatTime(order.createdAt || currentDate.toISOString())}</span>
              </p>
              <p>
                <span class="label">Status:</span>
                <span class="status-badge">${order.status || "Processando"}</span>
              </p>
            </div>
          </div>
          
          <div class="items-section">
            <h3>Itens do Pedido</h3>
            <table class="items-table">
              <thead>
                <tr>
                  <th style="width: 50%;">Item</th>
                  <th style="width: 15%; text-align: center;">Qtd</th>
                  <th style="width: 20%; text-align: right;">Preço Unit.</th>
                  <th style="width: 15%; text-align: right;">Total</th>
                </tr>
              </thead>
              <tbody>
                ${items
                  .map((item: any) => {
                    const nome = item.prato?.nome || item.nome || "Item"
                    const descricao = item.prato?.descricao || item.descricao || ""
                    const preco = item.prato?.preco || item.preco || 0
                    const quantidade = item.quantidade || 1
                    const itemTotal = preco * quantidade

                    return `
                    <tr>
                      <td>
                        <div class="item-name">${nome}</div>
                        ${descricao ? `<div class="item-description">${descricao}</div>` : ""}
                      </td>
                      <td class="item-quantity">${quantidade}</td>
                      <td class="item-price">${formatPrice(preco)}</td>
                      <td class="item-total">${formatPrice(itemTotal)}</td>
                    </tr>
                  `
                  })
                  .join("")}
              </tbody>
            </table>
          </div>
          
          <div class="total-section">
            <div class="total-row subtotal">
              <span>Subtotal:</span>
              <span>${formatPrice(total)}</span>
            </div>
            <div class="total-row subtotal">
              <span>Taxa de Serviço:</span>
              <span>Incluída</span>
            </div>
            <div class="total-row final">
              <span>Total Geral:</span>
              <span class="total-amount">${formatPrice(total)}</span>
            </div>
          </div>
        </div>
        
        <div class="invoice-footer">
          <p class="thank-you">Obrigado pela sua preferência!</p>
          <p class="note">Este documento serve como comprovante válido do seu pedido.</p>
          <p>Powered by <a href="#" class="powered-by">Syncmenu.ao</a></p>
        </div>
      </div>
    </body>
    </html>
  `
}

function downloadAsText(data: InvoiceData) {
  const { order, customerName, customerPhone, paymentMethod } = data
  const currentDate = new Date()

  const items = order.itens || []
  const total = items.reduce((sum: number, item: any) => {
    const preco = item.prato?.preco || item.preco || 0
    const quantidade = item.quantidade || 1
    return sum + preco * quantidade
  }, 0)

  const formatPrice = (price: number) => {
    return new Intl.NumberFormat("pt-AO", {
      style: "currency",
      currency: "AOA",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(price)
  }

  const textContent = `
Syncmenu
FATURA DE PEDIDO
Huíla, Angola

========================================

INFORMAÇÕES DO CLIENTE:
Nome: ${customerName}
Telefone: ${customerPhone}
Forma de Pagamento: ${paymentMethod}

DETALHES DO PEDIDO:
Número: #${order._id?.slice(-6) || "N/A"}
Data: ${currentDate.toLocaleDateString("pt-AO")}
Hora: ${currentDate.toLocaleTimeString("pt-AO", { hour: "2-digit", minute: "2-digit" })}
Status: ${order.status || "Processando"}

========================================

ITENS DO PEDIDO:

${items
  .map((item: any) => {
    const nome = item.prato?.nome || item.nome || "Item"
    const preco = item.prato?.preco || item.preco || 0
    const quantidade = item.quantidade || 1
    const itemTotal = preco * quantidade

    return `${quantidade}x ${nome} - ${formatPrice(itemTotal)}`
  })
  .join("\n")}

========================================

TOTAL GERAL: ${formatPrice(total)}

========================================

Obrigado pela sua preferência!
Powered by Syncmenu.ao
  `

  // Criar e baixar arquivo
  const blob = new Blob([textContent], { type: "text/plain;charset=utf-8" })
  const url = URL.createObjectURL(blob)
  const link = document.createElement("a")
  link.href = url
  link.download = `fatura_${order._id?.slice(-6) || "pedido"}_${currentDate.toISOString().slice(0, 10)}.txt`
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}
